import * as React from 'react';

export const About = () => {
   return (
      <div className="about">
      <h2 style={{color: 'black', fontWeight: '600'}}>Manage OMS IVR</h2>
      <br></br>
      <div className='body'>
      <p>
      This application, developed by Covingtion Creative, is for managing messages and routing in the OMS IVR.

      </p>
  
      </div> 
  
      <p>

        <br></br>
        <br></br>
      <div className="section-white">
          <h3 className="section-title">Messages</h3>
          <ul className="col-xs-4">
              <li>
                  Use the messages area to create, edit, and delete messages.
              </li>
              <li>
                  Use the messages area to activate and deactivate messages.
              </li>
              <li>
                  Messages are linked with a wav file that is played in the IVR at the appropriate time, if the message is active.
              </li>
                   </ul>
           <h3 className="section-title">Routes</h3>
                   <ul className="col-xs-4">
                       <li>
                           Use the routes area to create, edit, and delete routes.
                       </li>
                       <li>
                           Use the routes area to activate and deactivate routes.
                       </li>
                       <li>
                            Routes are used to define what happens at certain points of the callflow.
                       </li>
                       <li>
                       Since there can be multiple routes for a scenario, it is up to the user to avoid activating multiple routes at once.
                       </li>
                   </ul>
                   <h3 className="section-title">Users</h3>
                   <ul className="col-xs-4">
                       <li>
                           Use the users area to create, edit, and delete users and their associated rights.
                       </li>
                       <li>
                           The username must match a known and valid Active Directory account.
                       </li>               
                   </ul>
      </div>
      </p>
      
  </div>
   )
}